<template>
  <div class="footer-wrapper">
    <div class="footer1"></div>
    <div class="footer2"></div>
    <div class="footer-big-wrapper">
      <div class="footer-center">
        <div class="footer-section1">
          <img class="footer-img" src="/static/img/footerlogo.png" alt>
          <div class="footer-link-item">
            <div @click="toPage({name:'centerIntro'})">中心简介</div>
            <div @click="toPage({name:'centerMap'})">组织架构</div>
            <div @click="toPage({name:'centerLeader'})">中心领导</div>
            <div @click="toPage({name:'centerDuty'})">部门职责</div>
          </div>
          <div class="footer-link-item">
            <!-- <a href="http://www.ncosm.org.cn/ncosm/portal/index">标准管理</a> -->
            <div @click="toPage({name:'centerIntro'})">关于我们</div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="footer-link-item">
            <div
              @click="toPage({name:'CooperMajor', query: {
            showFlag: 0,
            type: 1
          }})"
            >重大专项</div>
            <div
              @click="toPage({name:'CooperMajor', query: {
            showFlag: 1,
            type: 2
          }})"
            >国际合作</div>
            <div @click="toPage({name:'education'})">教育培训</div>
            <div @click="toPage({name:'recruitment'})">人才招聘</div>
          </div>
          <div class="footer-link-item no-line">
            <div @click="toPage({name:'contractUs'})">联系我们</div>
            <div @click="toPage({name:'statement'})">版权声明</div>
            <a @click="SetHome()">设为首页</a>
            <a href="#" rel="sidebar" @click="addFavorite2()">加入收藏</a>
          </div>
        </div>
        <div class="footer-section2">
         <!-- <div class="ft-l">
            <img src="/static/img/dianhua.png" alt>
            <router-link to='/supervise' class="has-margin">纪检监察监督举报</router-link>
          </div> -->
          <div class="ft-r">
            <a href="http://bszs.conac.cn/sitename?method=show&id=068AAA78B12F057AE053022819AC91A7" target="_blank"><img src="/static/img/beian.png" alt></a>
            <img class="has-margin2" src="/static/img/jhui.png" alt>
            <span>津公网安备 12010402000540号</span>
            <span class="has-margin3">版权所有 国家海洋标准计量中心 津ICP备 08002640号-1</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import VueEvent from '../../../../static/js/vueEvent.js'
export default {
  data() {
    return {};
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },

    addFavorite2() {
      var url = window.location;
      var title = document.title;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("360se") > -1) {
        alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
      } else if (ua.indexOf("msie 8") > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      } else if (document.all) {
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
        }
      } else if (window.sidebar) {
        window.sidebar.addPanel(title, url, "");
      } else {
        alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
      }
    },
    SetHome(obj, vrl) {
      var vrl = window.location;
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(vrl);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
          var prefs = Components.classes[
            "@mozilla.org/preferences-service;1"
          ].getService(Components.interfaces.nsIPrefBranch);
          prefs.setCharPref("browser.startup.homepage", vrl);
        }
      }
    }
  }
};
</script>

<style scoped>
.footer-wrapper {
  width: 100%;
  position: relative;
}
.footer1 {
  width: 100%;
  height: 287px;
  /* background: url(/static/img/footer-bg.png) no-repeat center center; */
  background: #000000;
  background-size: 2560px 287px;
}
.footer2 {
  width: 100%;
  height: 67px;
  /* background: url(/static/img/footer-bg2.png) no-repeat center center; */
  background: #000000;
  background-size: 2560px 67px;
}
.footer-big-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.footer-center {
  width: 1277px;
  margin: 0 auto;
}
.footer-section1 {
  width: 100%;
  height: 287px;
  display: flex;
  padding: 19px 0;
  box-sizing: border-box;
  align-items: center;
  font-size: 18px;
  color: rgba(193, 217, 255, 1);
  line-height: 45px;
}
.footer-section2 {
  width: 1250px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-section2 .ft-l,.footer-section2 .ft-r{
  display: flex;
  align-items: center;
}
.footer-section2 .ft-r span{
  color: #fff;
  font-size: 14px;
}
.footer-img {
  flex: 0 0 249px;
  /* width: 249px; */
  height: 249px;
}
.has-margin{
  margin-left: 18px;
}
.has-margin2{
  margin-right: 6px;
  margin-left: 39px;
}
.has-margin3{
  margin-left: 28px;
}
.footer-link-item {
  /* width: 280px; */
  flex: 0 0 274px;
  min-height: 120px;
  text-align: center;
  border-right: 1px solid rgba(133, 153, 185, 1);
  color: rgba(193, 217, 255, 1);
}
.footer-link-item a{
  display: block;
  line-height: 45px;
  height: 45px;
  cursor: pointer;
  color: rgba(193, 217, 255, 1);
}
.footer-link-item div {
  line-height: 45px;
  height: 45px;
  cursor: pointer;
}
.no-line {
  border-right: none;
}
.footer-section2 img,
.footer-section2 a {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 67px;
  font-size: 14px;
}
.footer-link-item>div:hover{
  text-decoration: underline;
}
.footer-link-item>a:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/views/PartyBuilding/partyFoot.vue